<template>
  <div >
    <div class="tabs">
        <div
            class="tabs__item"
            v-for="(item) in tabs"
            :class="{active: selected == item.key}"
            :key="item.key"
            @click="selected = item.key"
        >
          {{item.title}}
        </div>
    </div>
    <div class="mcard mt-1" style="width: 90%;">
      <template v-if="selected == 'disc'">
        <div class="disc">
          <div class="d_wrap" v-html="item.description"></div>
          <div class="d-flex mt-3">
            <div class="tag" v-for="(tag,index) in item.tags" :key="index">
              #{{tag}}
            </div>
          </div>
        </div>
      </template>
      <template v-if="selected == 'prop'">
        <div class="disc">
          <table>
            <tr>
              <th>Параметр</th>
              <th>Значение</th>
            </tr>
            <tr v-for="attr in item.attributes" :key="attr.id">
              <th>{{attr.attribute.name}}</th>
              <th>{{attr.value.value}}</th>
            </tr>
            <!--<tr>
              <th>Вес(кг)</th>
              <th>35</th>
            </tr>-->
          </table>
        </div>
      </template>
      <template v-if="selected == 'docs'">
        <div class="row tab-container">
          <div class="col-6">
            <div class="tab-header">Инструкции</div>
            <div class="tab-icon-item" v-if="item.files">
              <img src="../../assets/icons/doc.svg"/>
              <div>
                <a target="_blank" :href="item.files" >Инструкция</a>
              </div>
            </div>
          </div>
          <div class="col-6  d-flex flex-column justify-content-between">
            <div>
              <div class="tab-header">Лицензии</div>
              <!--<div
                  class="tab-icon-item"
                  v-for="(itm, i) in licenses"
                  :key="i+'instr'"
              >
                <img src="../../assets/icons/doc.svg"/>
                <div>
                  {{itm}}
                </div>
              </div>-->
            </div>
            <div>
              <div>
                <div class="tab-header">Сертификаты</div>
                <!--<div
                    class="tab-icon-item"
                    v-for="(itm, i) in certificates"
                    :key="i+'instr'"
                >
                  <img src="../../assets/icons/doc.svg"/>
                  <div>
                    {{itm}}
                  </div>
                </div>-->
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-if="selected == 'promo'">
        <div class="tab-container">
          <!--<div class="row mb-4">
            <div class="col-3">
              <img src="../../assets/img/item/tabs/open.png" class="promo-img" width="100%">
            </div>
            <div class="col-9">
              <div class="tab-header">
                Распаковка рюкзака
              </div>
              <div class="disc h14 p-0 mb-3">
                WoodLand "Nek Pro 30"  -  современный рюкзак, сочетающий в себе простоту и технологии. Множество полезных деталей: карман и отверстие для питьевой системы, система развески снаряжения, эластичные боковые кармашки, быстрый доступ в основной отсек. Удивительно удобная подвеска VAS-BI с профессиональной системой вентиляции удовлетворит даже искушенного потребителя. WoodLand "Nek Pro 30"  -  современный рюкзак, сочетающий в себе простоту и технологии.
              </div>
              <div v-if="item.id == 24">
                <div class="tab-icon-item">
                  <img src="../../assets/icons/video_youtube.svg"/>
                  <div>
                    <a target="_blank" href="https://www.youtube.com/watch?v=CquJGEj2tEU">Видео</a>
                  </div>
                </div>
              </div>
              <div
                  class="tab-icon-item"
                  v-for="(itm, i) in instructions.slice(0,2)"
                  :key="i+'instr'"
              >
                <img src="../../assets/icons/video_youtube.svg"/>
                <div>
                  {{itm}}
                </div>
              </div>
            </div>
          </div>-->
          <!--<div class="row">
            <div class="col-3">
              <img src="../../assets/img/item/tabs/expluatation.png" class="promo-img" width="100%">
            </div>
            <div class="col-9">
              <div class="tab-header">
                Показ рюкзака
              </div>
              <div class="disc h14 p-0 mb-3">
                WoodLand "Nek Pro 30"  -  современный рюкзак, сочетающий в себе простоту и технологии. Множество полезных деталей: карман и отверстие для питьевой системы.
              </div>
              <div
                  class="tab-icon-item"
                  v-for="(itm, i) in instructions"
                  :key="i+'instr'"
              >
                <img src="../../assets/icons/video_youtube.svg"/>
                <div>
                  {{itm}}
                </div>
              </div>
            </div>
          </div>-->

        </div>
      </template>

    </div>
    <div style="width: 90%;">
      <div v-if="item.video_instruction" class="block-title">Видеоинструкция</div>
      <div class="video-instruction" v-if="item.video_instruction">
        <iframe :src="item.video_instruction" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </div>
      <div v-if="item.files">
        <a :href="item.files" class="download-instruction">
          <img src="../../assets/icons/download.svg" alt=""> скачать инструкцию
        </a>
      </div>
      <div v-if="item.about" class="block-title">О товаре</div>
      <div v-if="item.about">
        <vueper-slides fixed-height="265px" :bullets="false" class="no-shadow" :duration="250" :touchable="false">
          <template v-slot:arrow-left>
            <img src="../../assets/icons/arrow-left.svg" class="arrow">
          </template>
          <template v-slot:arrow-right>
            <img src="../../assets/icons/arrow-right.svg" class="arrow">
          </template>
          <vueper-slide v-for="(src, i) in item.about_slides" :key="i" :image="src"/>
        </vueper-slides>
      </div>
      <div v-if="item.product_use" class="block-title">Использование товара</div>
      <img :src="item.product_use_image" style="width: 100%" alt="">
      <div class="block-title">Отзывы и вопросы о <br>товаре</div>
    </div>
  </div>
</template>

<script>

import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'

export default {
  name: "tabs-info",
  components: { VueperSlides, VueperSlide},
  data: ()=>({
    tabs: [
      {
        title: 'Описание',
        key: 'disc',
      },
      {
        title: 'Характеристики',
        key: 'prop',
      },
      {
        title: 'Документы',
        key: 'docs',
      },
      {
        title: 'Промо материалы',
        key: 'promo',
      },
    ],
    instructions:[
        'Как собрать рюкзак',
        'Как собрать рюкзак',
        'Как собрать рюкзак',
        'Как собрать рюкзак',
    ],
    licenses: [
        'Лицензия н 2242353252 РПРПВВВ',
        'Лицензия н 2242353252 РПРПВВВ',
    ],
    certificates: [
      'Сертификат качества',
      'Сертификат качества',
    ],
    videos: [
        'Как мы распаковываем рюкзаки',
        'Из какого материала наши рюкзаки',
        'Как мы распаковываем рюкзаки',
        'Из какого материала наши рюкзаки',
        'Как мы распаковываем рюкзаки',
    ],
    selected: 'disc',
    tags: ['#рюкзаки','#сумки','#рюкзаки_для_похода','#рюкзак_красный_wood','#woodnek']
  }),
  props: {
    item: null
  }
}
</script>
<style lang="scss">

.download-instruction {
  color: #2CB181;
  font-size: 32px;
  display: block;
  margin-top: 20px;
  text-align: center;
}

.download-instruction:hover {
  text-decoration: none;
  color: #2CB181;
}

.video-instruction {
  height: 0;
  position: relative;
  padding-bottom: 56.25%;
}
.video-instruction iframe {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

.block-title {
  font-size: 35px;
  line-height: 54px;
  text-align: center;
  color: #2CB181;
  font-weight: bold;
  margin: 20px 0px 20px 0px;
}
.d_wrap{
  padding: 0;
  font-family: Roboto;
  font-style: normal;
  font-size: 12px;
  color: #7A818F;
  font-weight: 400;

  h1 {
    font-size: 16px;
    color: #2D3137;
  }
  h2, h3, h4, h5, h6, {
    color: #2D3137;
    font-size: 14px;
    line-height: 19px;
  }

  & > ul > li {
    list-style: none;
    padding: 0;
  }
  & > ul > li::before {
    content: '· ';
  }
}
</style>
<style scoped lang="scss">
.mcard{
  padding-bottom: 23px;
}
.tabs{
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  display: flex;
  justify-content: center;
  width: max-content;
  background-color: white;
  border-radius: 4px;
  border: 1px solid #EEF0F3;

  &__item {
    margin: 0;
    position: relative;
    cursor: pointer;
    padding: 10px 15px;
    margin: 2px 0 2px 0;
    color: #7A818F;
  }
  &__item:first-child{
    margin-left: 2px;
  }
  &__item:last-child{
    margin-right: 2px;
  }
  &__item.active {
    background: #EEF0F3;
    border-radius: 4px;
  }

  &__item:after{
    border-left: 1px solid #EEF0F3;
    content: " ";
    position: absolute;
    top: 35%;
    right: 0;
    height: 30%;
    margin-top: auto;
    margin-bottom: auto;
  }
  &__item:last-child:after{
    border-left: unset;
  }
}
.disc{
  padding: 18px 18px 0 18px ;
  font-size: 12px;
  line-height: 14px;
  color: #7A818F;
}
.tab-container{
  padding: 18px 18px 0 18px ;
}
.tab-header {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  margin-bottom: 13px;
}
.tab-icon-item{
  display: flex;
  align-items: center;
  color: #7A818F;
  font-family: Roboto;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  margin-bottom: 10px;
}
.tab-icon-item img {
  margin-right: 5px;
}
.tag{
  font-size: 12px;
  background: #EEF0F3;
  border-radius: 4px;
  padding: 8.5px 12px;
  color: #7A818F;
  margin-right: 2px;
}
.promo-img{
  object-fit: cover;
  max-height: 130px;
}
.h14{
  line-height: 14px;
}
</style>